<template>
  <div class="wrapper store-coop-list">
    <admin-title :title="$route.meta.name" />

    <div class="header-search">
      <el-form ref="searchForm" inline :model="searchData" label-width="">
        <el-form-item label="关键字" class="kw">
          <el-input
            v-model.trim="searchData.keyword"
            size="small"
            placeholder="请输入"
            clearable
            class="input-with-select"
          >
            <el-select
              v-model="searchData.keywordField"
              slot="prepend"
              placeholder="请选择"
              size="small"
              @change="onKeywordFieldChange"
            >
              <el-option
                v-for="item in keywordFieldOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="门店名称">
          <el-input
            v-model.trim="searchData.storeName"
            size="small"
            placeholder="请输入门店名称"
            clearable
            style="width: 180px"
          />
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker
            v-model="searchData.timeRange"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            size="small"
            class="joint-order-time-range"
          />
        </el-form-item>
        <el-form-item label="分账类型">
          <el-select
            v-model="searchData.royaltyType"
            size="small"
            placeholder="请选择"
            clearable
            style="width: 150px"
          >
            <el-option
              v-for="item in royaltyTypeOptions"
              :key="`${item.label}-${item.value}`"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="分账状态">
          <el-select
            v-model="searchData.royaltyStatus"
            size="small"
            placeholder="请选择"
            clearable
            style="width: 150px"
          >
            <el-option
              v-for="item in royaltyStatusOptions"
              :key="`${item.label}-${item.value}`"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select
            v-model="searchData.orderStatus"
            size="small"
            placeholder="请选择"
            clearable
            style="width: 150px"
          >
            <el-option
              v-for="item in orderStatusOptions"
              :key="`${item.label}-${item.value}`"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" size="small" icon="el-icon-search" @click="handleQuery">
            查询
          </el-button>
          <el-button type="info" size="small" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-divider />
    <div class="toolbar-right">
      <el-button
        v-checkbtn="isShowBtn(AUTH_BTN.store_cooperation_joint_order_export)"
        type="primary"
        size="small"
        icon="el-icon-download"
        @click="exportExcel"
      >
        导出
      </el-button>
    </div>

    <tp-table
      :isNeedSerialNumber="true"
      :isCheckBox="false"
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
    />

    <SplitDetailDialog :visible.sync="splitDialog.visible" :row="splitDialog.row" />
  </div>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";
import {
  getJointOrderPageAPI,
  exportJointOrderAPI,
} from "./api";
import SplitDetailDialog from "./components/split-detail-dialog.vue";

/** 分账类型：1按期 2提前买断 3订单取消 4提前回购 */
const royaltyTypeOptions = [
  { label: "全部", value: "" },
  { label: "按期分账", value: 1 },
  // { label: "提前买断分账", value: 2 },
  { label: "订单取消分账", value: 3 },
  // { label: "提前回购分账", value: 4 },
];

/** 分账状态：1分账中 2已完成 */
const royaltyStatusOptions = [
  { label: "全部", value: "" },
  { label: "分账中", value: 1 },
  { label: "已完成", value: 2 },
];

/** 订单状态（与接口 orderStatus 一致） */
const orderStatusOptions = [
  { label: "全部", value: "" },
  { label: "审核中", value: 1 },
  { label: "待支付", value: 2 },
  { label: "待签章", value: 3 },
  { label: "待发货", value: 4 },
  { label: "待收货", value: 5 },
  { label: "租赁中", value: 6 },
  { label: "逾期中", value: 7 },
  { label: "待买断", value: 8 },
  { label: "待归还", value: 9 },
  { label: "已完成", value: 91 },
  { label: "已取消", value: 92 },
  { label: "已拒绝", value: 93 },
];

/** 关键字查询字段 */
const keywordFieldOptions = [
  { label: "订单号", value: "orderNo" },
  { label: "用户姓名", value: "memberName" },
  { label: "手机号", value: "memberMobile" },
];

function coopJLine(h, label, val) {
  const text = val != null && val !== "" ? val : "-";
  return (
    <div class="j-line">
      <span class="lbl">{label}：</span>
      <span class="val">{text}</span>
    </div>
  );
}

const columns = [
  {
    label: "用户信息",
    prop: "memberInfo",
    minWidth: "180",
    customRender(h, row) {
      return (
        <div class="joint-cell">
          {coopJLine(h, "姓名", row.memberName)}
          {coopJLine(h, "手机", row.memberMobile)}
        </div>
      );
    },
  },
  {
    label: "订单信息",
    prop: "orderInfo",
    minWidth: "280",
    customRender(h, row) {
      return (
        <div class="joint-cell">
          {coopJLine(h, "订单号", row.orderNo)}
          {coopJLine(h, "下单时间", row.orderCreateTime)}
          {coopJLine(h, "订单状态", row.orderStatusName)}
        </div>
      );
    },
  },
  {
    label: "门店信息",
    prop: "storeInfo",
    minWidth: "280",
    customRender(h, row) {
      return (
        <div class="joint-cell">
          {coopJLine(h, "门店名称", row.storeName)}
          {coopJLine(h, "门店地址", row.storeAddress)}
          {coopJLine(h, "区域负责人", row.areaFollowUserName)}
        </div>
      );
    },
  },
  {
    label: "联营模式",
    prop: "storeJointModeName",
    minWidth: "100",
    customRender(h, row) {
      return <p class="joint-plain">{row.storeJointModeName || "-"}</p>;
    },
  },
  {
    label: "融资信息",
    prop: "investInfo",
    minWidth: "250",
    customRender(h, row) {
      return (
        <div class="joint-cell">
          {coopJLine(h, "融资比例", row.investRate)}
          {coopJLine(h, "融资金额", row.investPrice)}
          {coopJLine(h, "融资时间", row.investTime)}
        </div>
      );
    },
  },
  {
    label: "门店收益",
    prop: "storeProfit",
    minWidth: "180",
    customRender(h, row) {
      return (
        <div class="joint-cell">
          {coopJLine(h, "收益率", row.profitRate)}
          {coopJLine(h, "预估收益", row.estProfitAmount)}
        </div>
      );
    },
  },
  {
    label: "分账计划",
    prop: "royaltyPlan",
    minWidth: "220",
    customRender(h, row) {
      return (
        <div class="joint-cell">
          {coopJLine(h, "计划分账期数", row.planRentRoyaltyNum)}
          {coopJLine(h, "已分账期数", row.execRentRoyaltyNum)}
          {coopJLine(h, "计划分账金额", row.planRentRoyaltyPrice)}
          {coopJLine(h, "已分账金额", row.execRentRoyaltyPrice)}
        </div>
      );
    },
  },
  {
    label: "订单取消分账",
    prop: "execOtherRoyaltyPrice",
    minWidth: "120",
    align: "left",
    customRender(h, row) {
      return <p class="joint-plain">{row.execOtherRoyaltyPrice || "-"}</p>;
    },
  },
  {
    label: "已分账本金",
    prop: "execPrincipleRoyaltyPrice",
    minWidth: "100",
    align: "left",
    customRender(h, row) {
      return <p class="joint-plain">{row.execPrincipleRoyaltyPrice || "-"}</p>;
    },
  },
  {
    label: "已分账收益",
    prop: "execProfitRoyaltyPrice",
    minWidth: "100",
    align: "left",
    customRender(h, row) {
      return <p class="joint-plain">{row.execProfitRoyaltyPrice || "-"}</p>;
    },
  },
  {
    label: "已分账总金额",
    prop: "execTotalRoyaltyPrice",
    minWidth: "120",
    align: "left",
    customRender(h, row) {
      return <p class="joint-plain">{row.execTotalRoyaltyPrice || "-"}</p>;
    },
  },
  {
    label: "分账类型",
    prop: "royaltyTypeName",
    minWidth: "150",
    customRender(h, row) {
      return <p class="joint-plain">{row.royaltyTypeName || "-"}</p>;
    },
  },
  {
    label: "分账状态",
    prop: "royaltyStatusName",
    minWidth: "110",
    customRender(h, row) {
      const name = row.royaltyStatusName;
      // 无需分账显示 -
      return <p class="joint-plain">{name && name !== "无需分账" ? name : "-"}</p>;
    },
  },
  {
    label: "操作",
    width: "100",
    fixed: "right",
    customRender(h, row) {
      const can = this.isShowBtn(this.AUTH_BTN.store_cooperation_joint_order_split_detail);
      if (!can) {
        return <span>-</span>;
      }
      return (
        <el-link underline={false} type="primary" onClick={() => this.openSplitDetail(row)}>
          分账明细
        </el-link>
      );
    },
  },
];

export default {
  name: "JointOrderList",
  mixins: [authBtnMixin],
  components: { SplitDetailDialog },
  data() {
    return {
      columns,
      keywordFieldOptions,
      royaltyTypeOptions,
      royaltyStatusOptions,
      orderStatusOptions,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        keywordField: "orderNo",
        keyword: "",
        storeName: "",
        timeRange: null,
        royaltyType: "",
        royaltyStatus: "",
        orderStatus: "",
      },
      splitDialog: {
        visible: false,
        row: {},
      },
    };
  },
  provide() {
    return {
      context: this,
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    onKeywordFieldChange() {
      this.searchData.keyword = "";
    },
    buildQueryParams() {
      const params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        storeName: this.searchData.storeName || undefined,
      };
      const keyword = (this.searchData.keyword || "").trim();
      if (keyword) {
        params[this.searchData.keywordField] = keyword;
      }
      // 下单时间范围
      const range = this.searchData.timeRange;
      if (range && range.length === 2) {
        params.leftOrderCreateDate = range[0];
        params.rightOrderCreateDate = range[1];
      }
      if (this.searchData.royaltyType !== "" && this.searchData.royaltyType != null) {
        params.royaltyType = this.searchData.royaltyType;
      }
      if (this.searchData.royaltyStatus !== "" && this.searchData.royaltyStatus != null) {
        params.royaltyStatus = this.searchData.royaltyStatus;
      }
      if (this.searchData.orderStatus !== "" && this.searchData.orderStatus != null) {
        params.orderStatus = this.searchData.orderStatus;
      }
      return params;
    },
    handleQuery() {
      this.currentPage = 1;
      this.getList();
    },
    reset() {
      this.searchData = {
        keywordField: "orderNo",
        keyword: "",
        storeName: "",
        timeRange: null,
        royaltyType: "",
        royaltyStatus: "",
        orderStatus: "",
      };
      this.currentPage = 1;
      this.getList();
    },
    async getList() {
      try {
        const res = await getJointOrderPageAPI(this.buildQueryParams());
        this.list = res.list || [];
        this.total = res.total || 0;
      } catch (e) {
        this.list = [];
        this.total = 0;
      }
    },
    buildExportParams() {
      const range = this.searchData.timeRange;
      const params = {
        orderNo: "",
        storeName: this.searchData.storeName || "",
        memberName: "",
        memberMobile: "",
        leftOrderCreateDate: range && range.length === 2 ? range[0] : "",
        rightOrderCreateDate: range && range.length === 2 ? range[1] : "",
        royaltyType:
          this.searchData.royaltyType !== "" && this.searchData.royaltyType != null
            ? String(this.searchData.royaltyType)
            : "",
        royaltyStatus:
          this.searchData.royaltyStatus !== "" && this.searchData.royaltyStatus != null
            ? String(this.searchData.royaltyStatus)
            : "",
        orderStatus:
          this.searchData.orderStatus !== "" && this.searchData.orderStatus != null
            ? String(this.searchData.orderStatus)
            : "",
      };
      const keyword = (this.searchData.keyword || "").trim();
      if (keyword) {
        params[this.searchData.keywordField] = keyword;
      }
      return params;
    },
    exportExcel() {
      exportJointOrderAPI(this.buildExportParams());
    },
    /** 打开分账明细，row.id 为联营订单 ID */
    openSplitDetail(row) {
      this.splitDialog.row = { ...row };
      this.splitDialog.visible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.joint-order-time-range {
  width: 260px;
}

.toolbar-right {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}

::v-deep .kw {
  .el-select .el-input {
    width: 118px;
  }

  .el-select {
    width: 120px;
  }

  .input-with-select {
    vertical-align: middle;
    width: 320px;
  }

  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
}
</style>

<style lang="scss">
@import "../coop-list-table-cells.scss";
</style>
